import {
  AnswersProjection,
  questionHasChildren,
  QuestionProjection,
  QuestionType,
  QuestionTypesWithChildren,
} from "@lookiero/sty-psp-quiz-style-profile-common-ui";

interface SortQuestionAnswerByDefinitionFunctionArgs {
  readonly question: QuestionProjection;
  readonly answer: string[];
}

interface SortQuestionAnswerByDefinitionFunction {
  (args: SortQuestionAnswerByDefinitionFunctionArgs): string[];
}

const sortQuestionAnswerByDefinition: SortQuestionAnswerByDefinitionFunction = ({ question, answer }) => {
  if (
    [
      QuestionType.HOST_DATE,
      QuestionType.HOST_HEIGHT_IMPERIAL,
      QuestionType.HOST_HEIGHT_METRIC,
      QuestionType.HOST_WEIGHT_IMPERIAL,
      QuestionType.HOST_WEIGHT_METRIC,
    ].includes(question.type)
  ) {
    return answer;
  }

  if (!questionHasChildren(question)) {
    return answer;
  }

  let sortedAnswer: string[] = [];

  const sortAnswer = (question: QuestionProjection<QuestionTypesWithChildren>): void => {
    for (let i = 0; i < question.children.length; i++) {
      const childQuestion = question.children[i] as QuestionProjection;

      if (answer.includes(childQuestion.id) && !sortedAnswer.includes(childQuestion.id)) {
        sortedAnswer = [...sortedAnswer, childQuestion.id];
      }

      if (questionHasChildren(childQuestion)) {
        sortAnswer(childQuestion);
      }
    }
  };

  sortAnswer(question);

  return sortedAnswer;
};

interface SortQuestionAnswersByDefinitionFunctionArgs {
  readonly question: QuestionProjection;
  readonly answers: AnswersProjection;
}

interface SortQuestionAnswersByDefinitionFunction {
  (args: SortQuestionAnswersByDefinitionFunctionArgs): AnswersProjection;
}

const sortQuestionAnswersByDefinition: SortQuestionAnswersByDefinitionFunction = ({ question, answers }) => {
  const sortedAnswers: AnswersProjection = {};

  const mapQuestion = (question: QuestionProjection) => {
    const questionAnswer = answers[question.id];

    if (questionAnswer) {
      sortedAnswers[question.id] = sortQuestionAnswerByDefinition({ question, answer: questionAnswer });
    }

    if (questionHasChildren(question)) {
      question.children.forEach(mapQuestion);
    }
  };

  mapQuestion(question);

  return sortedAnswers;
};

export { sortQuestionAnswersByDefinition };
